export const DEPARTMENT_COLORS = [
  // REDS
  "#DC2626",
  "#EF4444",

  // ORANGES
  "#EA580C",
  "#F97316",

  // AMBER / GOLD
  "#D97706",
  "#F59E0B",

  // YELLOWS
  "#CA8A04",
  "#EAB308",

  // LIME
  "#65A30D",
  "#84CC16",

  // GREENS
  "#16A34A",
  "#22C55E",

  // EMERALD
  "#059669",
  "#10B981",

  // TEAL
  "#0F766E",
  "#14B8A6",

  // CYAN
  "#0891B2",
  "#06B6D4",

  // SKY
  "#0284C7",
  "#0EA5E9",

  // BLUE
  "#2563EB",
  "#3B82F6",

  // INDIGO
  "#4338CA",
  "#6366F1",

  // VIOLET
  "#6D28D9",
  "#8B5CF6",

  // PURPLE
  "#7E22CE",
  "#A855F7",

  // FUCHSIA
  "#A21CAF",
  "#D946EF",

  // PINK
  "#DB2777",
  "#EC4899",

  // ROSE
  "#BE123C",
  "#F43F5E",

  // EXTRA DISTINCTIVE ENTERPRISE COLORS
  "#1D4ED8",
];